import React, { useRef, useState } from 'react';
import { BackBoldArrowIcon } from '../../assets/icons';
import DropdownListPanel, { type DropdownItem } from './DropdownListPanel';
import { useClickOutside } from './useClickOutside';
import * as S from './DropdownStyled';
import type { DropdownSize } from './DropdownStyled';

export type { DropdownItem } from './DropdownListPanel';
export type { DropdownSize } from './DropdownStyled';

export type DropdownProps = {
	value: DropdownItem;
	options: readonly DropdownItem[];
	onChange: (value: DropdownItem) => void;
	dropdownWidth?: number;
	/**
	 * data-testid для кнопки-триггера дропдауна (кнопка выбора учебного года и т.п.)
	 */
	dataTestId?: string;
    size?: DropdownSize;
};

const Dropdown = ({
  value,
  options,
  onChange,
  dropdownWidth = 268,
  size = 'l',
  dataTestId,
}: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useClickOutside({
    isActive: isOpen,
    containerRef: wrapRef,
    onOutside: () => setIsOpen(false),
  });

  const handleSelect = (option: DropdownItem) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <S.DropdownWrap ref={wrapRef}>
      <S.DropdownTrigger
        type="button"
        $size={size}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        data-testid={dataTestId}
      >
        <S.DropdownTriggerLabel $underline={size === 'l'}>{value.label}</S.DropdownTriggerLabel>
        <S.DropdownArrow $open={isOpen} $size={size}>
          <BackBoldArrowIcon />
        </S.DropdownArrow>
      </S.DropdownTrigger>

      <DropdownListPanel
        open={isOpen}
        targetRef={wrapRef.current || undefined}
        width={dropdownWidth}
        zIndex={10}
        options={options}
        selectedValue={value.value}
        onSelect={handleSelect}
        showSelectedCheck
      />
    </S.DropdownWrap>
  );
};

export default Dropdown;
